// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3-cc2","title":"ClientInsurance_title__1ijEv","itemText":"ClientInsurance_itemText__1HCN5"};